import axios from 'axios';

export const editGalleryAlbumSection = async (e) => {
  const { data } = await axios.post('/PgSection/EditSectionGalleryAlbum', e);
  return data;
};
